import { ShopHistoryStatus } from '@/schema'

export const SHOP_QUERY_KEYS = {
	ITEMS: {
		ALL: ['shop', 'items'] as const,
		LIST: (query: any) =>
			[...SHOP_QUERY_KEYS.ITEMS.ALL, 'list', query] as const,
		DETAIL: (id: string) =>
			[...SHOP_QUERY_KEYS.ITEMS.ALL, 'detail', id] as const,
	},
	PURCHASES: {
		ALL: ['shop', 'purchases'] as const,
		LIST: (query: any) =>
			[...SHOP_QUERY_KEYS.PURCHASES.ALL, 'list', query] as const,
		DETAIL: (id: string) =>
			[...SHOP_QUERY_KEYS.PURCHASES.ALL, 'detail', id] as const,
	},
} as const

export const REWARD_TYPE_OPTIONS = [
	{ value: 'CREDIT', label: 'เครดิต' },
	{ value: 'FREE_SPIN', label: 'ฟรีสปิน' },
	{ value: 'ITEM', label: 'สินค้า' },
] as const

export const PURCHASE_STATUS_OPTIONS = [
	{ value: ShopHistoryStatus.PENDING, label: 'รอดำเนินการ' },
	{ value: ShopHistoryStatus.SUCCESS, label: 'สำเร็จ' },
	{ value: ShopHistoryStatus.FAILED, label: 'ล้มเหลว' },
] as const

export const CURRENCY_TYPE_OPTIONS = [
	{ value: 'DIAMOND', label: 'เพชร' },
	{ value: 'CREDIT', label: 'เครดิต' },
] as const
